<div class="header-container">
    <h1 class="title">
        IXH24 - Italian XRPL Hackathon 2024
    </h1>
    <p class="subtitle">
        <b> Rome, Nov. 22nd, 23rd </b>
    </p>
</div>

<div class="toptext">
    <p class="intro-text">
        <span class="highlight">IXH24</span> is a national hackathon with a focus on cryptography and blockchain. This
        two-day event
        will feature a mix of insightful seminars, engaging discussions, and significant hands-on experience.
        It is jointly organized by <span class="highlight">XRPL Commons</span>, a leading blockchain community,
        <span class="highlight">De Componendis Cifris</span>, the Italian association of cryptography, and <span
            class="highlight">Roma Tre University</span>.
        <br>
        The hackathon will bring together teams of students from Italian universities, with students from across
        Europe also welcome to join and participate.
        <br><br>
        Set in the eternal city of <span class="highlight">Rome</span>, the event will take place from
        <span class="highlight highlight-date"><i class="fa fa-calendar-alt"></i> November 22nd to 23rd, 2024</span>,
        with a total prize pool of <span class="highlight highlight-prize">€10,000</span>.
        <span class="highlight highlight-date"><i class="fa-solid fa-ticket"></i><a class="register-link"
                [routerLink]="['/ixh24']" fragment="teams"> Register now, tickets are limited!</a></span>
    </p>
    <div class="image-container-horizontal" style="margin-bottom: 0;">
        <a [routerLink]="['/ixh24']" fragment="tracks" class="track-wrapper">
            <div class="track-overlay">
                Cryptography Track
            </div>
            <img src="../../../../assets/images/events/2024/ixh24/CYPTO_track.jpg" alt="Cryptography">
        </a>
        <a [routerLink]="['/ixh24']" fragment="tracks" class="track-wrapper">
            <div class="track-overlay">
                XRPL Track
            </div>
            <img src="../../../../assets/images/events/2024/ixh24/XRPL_track.png" alt="XRPL">
        </a>
    </div>
</div>
<div class="table-of-contents">
    <div class="toc-buttons">
        <a mat-button [routerLink]="['/ixh24']" fragment="schedule">Schedule</a>
        <a mat-button [routerLink]="['/ixh24']" fragment="rules">Details</a>
        <a mat-button [routerLink]="['/ixh24']" fragment="tracks">Tracks</a>
        <a mat-button [routerLink]="['/ixh24']" fragment="teams">Teams</a>
    </div>
</div>
<div class="image-container-horizontal">
    <div class="image-wrapper">
        <img src="../../../../assets/images/events/2024/ixh24/sanpaolo.jpg">
    </div>
    <div class="image-wrapper">
        <img src="../../../../assets/images/events/2024/ixh24/rettorato.jpg">
    </div>
</div>
<div class="image-container-horizontal">
    <a href="https://www.decifris.it" target="_blank" class="image-wrapper-vertical">
        <img src="../../../../assets/images/icons/decifris.svg" alt="Decifris logo">
    </a>
    <a href="https://www.xrpl-commons.org/" target="_blank" class="image-wrapper-vertical">
        <img src="../../../../assets/images/logos/xrplcommons.webp" alt="XRPL Commons logo">
    </a>
    <a href="https://www.uniroma3.it/" target="_blank" class="image-wrapper-vertical">
        <img src="../../../../assets/images/logos/roma3_blue.png" alt="Roma Tre logo">
    </a>
    <a href="https://ripple.com/impact/ubri/" target="_blank" class="image-wrapper-vertical">
        <img src="../../../../assets/images/logos/rippleimpact.png" alt="Ripple Impact logo">
    </a>
</div>


<hr id="schedule">
<h2>Schedule</h2>

<table class="orari" cellspacing="2" cellpadding="2">
    <tr bgcolor="lightblue">
        <th class="schedule" colspan="2">
            <font size="+1"><b>November 22nd </b></font>
            <br>
            <b class="location">Location: Rectorate, Roma Tre University - via Ostiense 133 (Roma)</b>
        </th>
    </tr>
    <tr>
        <td class="schedule">
            8:00<br>9:00
        </td>
        <td>
            <i>
                <b>Arrival</b> and registration<br>
                <i class="location">Rectorate, tower A - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            9:00<br>9:30
        </td>
        <td>
            <i>
                <b>Welcome reception</b> and coffee<br>
                <i class="location">Rectorate, tower A - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            9:30<br>10:00
        </td>
        <td>
            <i>
                <b>Welcome speeches</b>
                <ul class="speakers">
                    <li>Roma Tre University</li>
                    <li>De Componendis Cifris</li>
                    <li>XRPL Commons</li>
                </ul>
                <i class="location">Rectorate, tower A - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            10:00<br>12:00
        </td>
        <td>
            <i>
                <b>XRPL workshop</b><br>
                <i class="location">Rectorate, tower A - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            12:00<br>13:00
        </td>
        <td>
            <i>
                <b>Lunch break</b>, hackathon instructions and final team registration<br>
                <i class="location">Rectorate, tower A - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            13:00
        </td>
        <td>
            <i>
                <b>Hackathon starts</b><br>
                <i class="location">Rectorate, tower C - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
</table>

<table class="orari" cellspacing="2" cellpadding="2">
    <tr bgcolor="lightblue">
        <th class="schedule" colspan="2">
            <font size="+1"><b>November 23rd </b></font>
            <br>
            <b class="location">Location: Rectorate, Roma Tre University - via Ostiense 133 (Roma)</b>
        </th>
    </tr>
    <tr>
        <td class="schedule">
            9:00<br>9:30
        </td>
        <td>
            <i>
                <b>Breakfast</b> and coffee<br>
                <i class="location">Rectorate, tower C - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            11:00
        </td>
        <td>
            <i>
                <b>Final project submission</b> (code & pitch)<br>
                <i class="location">Rectorate, tower C - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            11:00<br>13:00
        </td>
        <td>
            <i>
                <b>Project pitches</b><br>
                <i class="location">Rectorate, tower A - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            13:00<br>14:00
        </td>
        <td>
            <i>
                <b>Lunch break</b> and jury deliberation<br>
                <i class="location">Rectorate, tower A - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            14:00<br>14:30
        </td>
        <td>
            <i>
                <b>Award ceremony</b>, joint with the separate Secondary School hackathon<br>
                <i class="location">Rectorate, tower A - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
    <tr>
        <td class="schedule">
            14:30<br>16:00
        </td>
        <td>
            <i>
                <b>XRPL Commons meet-up</b>, informal meeting with the community<br>
                <i class="location">Rectorate, tower C - via Ostiense 133 </i>
            </i>
        </td>
    </tr>
</table>

<hr id="rules">
<h2>Hackathon details</h2>
<div class="text">
    <details>
        <summary>
            <b class="rule-name">1. Coding and projects</b>
        </summary>
        <ul>
            <li><b>Coding starts</b> at 13:00 on November 22rd and <b>submissions close</b> at 11:00 on November
                23rd
                (UTC+2).</li>
            <li><b>New work only:</b> coding, development, and design should be done during the hackathon. Any work
                that
                was completed prior to the hackathon must be mentioned in your submission. Non-team-created software
                or
                intellectual property can be utilised if you have a licence
                (e.g. software
                libraries or design assets), but they must be mentioned in your submission.</li>
            <li><b>Project pitches</b> will be of five minutes, followed by two minutes for questions. You can
                include
                a
                PowerPoint/PDF presentation. A live demo is also accepted (and encouraged).</li>
            <li><b>Code versioning:</b> all submitted code must be in a version-controlled repository (e.g., GitHub)
                and
                made
                accessible to judges at the time of submission.</li>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">2. Participants</b>
        </summary>
        <ul>
            <li>
                To be a <b>participant</b>, you need
                <ol>
                    <li>to have legal rights to be in Rome from the 21-st to the 23-rd of November 2024 (e.g., if you
                        are an EU
                        citizen),</li>
                    <li>to be at least 18-year old on the 31-st of December 2024, and </li>
                    <li>to register following the <a [routerLink]="['/ixh24']" fragment="teams">registration
                            procedure</a>.</li>
                </ol>
            </li>
            <li>
                We will not provide any documentation about your participation <b>before</b>
                the event. An attendance certificate will be provided <b>after</b> the event.
            </li>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">3. Students</b>
        </summary>
        <ul>
            <li>To be considered a <b>student</b>
                either be
                enrolled as a BSC (<i>"laurea triennale"</i>), MSC (<i>"laurea magistrale"</i>), PHD
                (<i>"dottorato"</i>) student or have
                graduated as such in 2022, 2023 or 2024.</li>
            <li>
                This is a prerequisite to be part of an Italian University Team. Read more below at point 5.
            </li>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">4. Teams</b>
        </summary>
        <ul>
            <li>
                Teams can consist of 3 to 7 participants. Participants may only be part of one team.</li>
            <li>If a participant wants to register and be affiliated with a team, he/she must write to <a
                    href="mailto:hack@decifris.it">hack&#64;decifris.it</a> and
                communicate the chosen team leader, no later than November 15th.</li>
            <li>If a participant does not declare a team leader in time, he/she will become part of teams formed by the
                organizers at the beginning of the event (in the morning of the 22-nd of Novembre 2024).</li>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">5. Italian University Teams (IUTs)</b>
        </summary>
        <ul>
            <li>Italian universities may have one or more affiliated teams (IUTs).</li>
            <li>IUTs team leaders must register to the hackathon, both in Eventbrite and sending an email to
                <a href="mailto:hack@decifris.it">hack&#64;decifris.it</a>,
                no later than November 11th.
            </li>
            <li>IUTs team members must register to the hackathon, both in Eventbrite and sending an email to
                <a href="mailto:hack@decifris.it">hack&#64;decifris.it</a>,
                no later than November 15th.
            </li>
            <li>To be part of an IUT, you must satisfy:
                <ol>
                    <li>the requirements to be a participant</li>
                    <li>the requirements to be a student (of said University)</li>
                    <li>to be either a nonEU citizen or a EU citizen who is also a member of De Cifris (or that he/she
                        has applied for
                        membership)</li>
                </ol>
            </li>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">6. Tracks and projects</b>
        </summary>
        <ul>
            <li>
                The hackathon consists of two tracks, which correspond to two different challenges. Each team
                will select its own track during the event and submit only one project. <br>
                Details on the challenges will be given during the event.
            </li>
            <li><b>Track 1: Advanced cryptography for blockchain</b>
                <br>
                Projects under this track must demonstrate a clear application of cryptographic techniques to
                solve the
                challenge. The challenge can include, but is not limited to, encryption algorithms, zero-knowledge
                proofs,
                digital signatures, or other privacy-enhancing technologies.
            </li>
            <li><b>Track 2: XRPL applications</b>
                <br>
                Projects under this track must involve the XRP Ledger in some way, whether
                through integrations, apps, decentralised finance,
                or smart contracts. Creativity and innovation in utilising the XRP ledger to solve the challenge are
                highly encouraged.
            </li>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">7. Judging criteria</b>
        </summary>
        <ul>
            <li><b>Innovation</b>: How original is the idea? Does it bring new insights or solutions?
            </li>
            <li><b>Execution</b>: How well was it developed? Does it demonstrate technical complexity or impressive
                engineering?</li>
            <li><b>Impact</b>: How impactful is the project? Does it add value to a particular community, scenario
                or
                industry?</li>
            <li><b>Pitch</b>: Is the project clearly communicated? Is the demo (if present) well-prepared and
                convincing?</li>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">8. Prizes and awards</b>
        </summary>
        <ul>
            <li>
                Prizes will be awarded to the top 3 projects in each track:
                <ol>
                    <li>1st winner: € 2500 (two thousands and five hundreds)</li>
                    <li>2nd winner: € 1500 (one thousand and five hundreds)</li>
                    <li>3rd winner: € 500 (five hundreds)</li>
                </ol>
            </li>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">9. Disqualification and misconduct</b>
        </summary>

        <ul>
            <li>
                Participants will be disqualified if they:
            </li>
            <ol>
                <li>Fail to comply with intellectual property or copyright rules.</li>
                <li>Submit projects containing offensive, discriminatory, or harmful content.</li>
                <li>Exhibit any form of cheating, including tampering with other teams' projects.</li>
            </ol>
        </ul>
    </details>
    <details>
        <summary>
            <b class="rule-name">10. Miscellanea</b>
        </summary>
        <ul>
            <li>
                <b>Funding for eligible participants:</b>
                if you are a student (as defined above at point 3) and <a href="/associazione/associarsi">a DeCifris
                    member</a> (or
                you are applying for membership), you are eligible for both a refund of your travel expenses and free
                accomodation for two/three nights (that we provide). Young membership only costs 5 euros. If you think
                that you are eligible, please contact us at <a href="mailto:hack@decifris.it">hack&#64;decifris.it</a>
                as soon as possible for confirmation (no later than November 15th) and the relevant paperwork.
            </li>
            <li><b>Code of conduct:</b> All participants are expected to ensure a respectful environment.</li>
            <li><b>Venue:</b> The main venue is the rectorate of Roma Tre University (via Ostiense 133, Roma). The
                complex closes between 21:00 (22nd) and 08:00 (23rd): you will be welcome to stay there overnight, but
                for
                security reasons you will only be able to exit, not enter, before 08:00. </li>
            <li><b>Support and Mentorship:</b> Mentors will be available to assist with technical or project-related
                queries.</li>
            <li><b>FAQs:</b> additional questions may be asked before or during the event <span
                    class="highlight highlight-date"><i class="fa-brands fa-discord"></i> in our new De Cifris
                    <a href="https://discord.gg/4nckwwWhuH" class="register-link">Discord
                        server</a>
                </span>, still under construction.</li>
        </ul>
    </details>
</div>

<hr id="tracks">

<h2>Tracks</h2>
<div class="text">
    Details on the challenges of the two tracks will be given at the start of the event.
    <br>
    Some general information in the <a [routerLink]="['/ixh24']" fragment="rules">hackathon details</a>
</div>

<hr id="teams">


<h2>Teams</h2>
<section class="teams-section">
    <div class="text">
        <h3>Registration</h3>
        <div class="registration-info">
            <p>Tickets for <span class="highlight">IXH24</span> are limited,
                <span class="highlight highlight-date"><i class="fa-solid fa-ticket"></i> register now
                    <a href="https://www.eventbrite.fr/e/ixh24-italian-xrpl-hackathon-2024-tickets-1042856701467"
                        class="register-link">via Eventbrite</a>.
                </span>
                <br>
                If you are an Italian university wishing to participate with your own team, or if you are an aspiring
                team leader for an Italian university, write us at <a
                    href="mailto:hack@decifris.it">hack&#64;decifris.it</a>
                (
                <span class="highlight highlight-date">

                    <a class="register-link" [routerLink]="['/ixh24']" fragment="rules"><i class="fa-solid fa-list-ol">
                        </i> read more</a>
                </span>).
            </p>
        </div>

        <h3>Confirmed Teams</h3>
        <p>In order of addition.</p>
        <div class="teams-list">
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Perugia</b>
                    <span class="team-leader">Team leader: <i>Giorgia Caselli</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Bari</b>
                    <span class="team-leader">Team leader: <i>Luca Nestore</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Trento</b>
                    <span class="team-leader">Team leader: <i>Marco Marchesin</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Napoli Federico II</b>
                    <span class="team-leader">Team leader: <i>Francesco Lucibello</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Trento</b>
                    <span class="team-leader">Team leader: <i>Michele Panariello</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Roma Tre</b>
                    <span class="team-leader">Team leader: <i>Nicoletta Falcone</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa-solid fa-briefcase"></i>
                <div class="team-details">
                    <b class="university-name">Namirial SPA</b>
                    <span class="team-leader">Team leader: <i>Giulio di Clemente</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">University of Birmingham</b>
                    <span class="team-leader">Team leader: <i>TBA</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Roma La Sapienza</b>
                    <span class="team-leader">Team leader: <i>Vincenzo Imperati</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Roma Tre</b>
                    <span class="team-leader">Team leader: <i>Desiana Fancellu</i></span>
                </div>
            </div>
            <div class="team-card">
                <i class="fa fa-graduation-cap"></i>
                <div class="team-details">
                    <b class="university-name">Università di Roma Tre</b>
                    <span class="team-leader">Team leader: <i>Hossain Meah</i></span>
                </div>
            </div>
        </div>
    </div>
</section>